import { useNavigate } from 'react-router-dom';
import { LISTADOS_CICLO, LISTADOS_OTROS } from '../../pages/Listados/definiciones';

/**
 * Los otros listados, a un click desde cualquier listado.
 *
 * POR QUÉ
 * Los listados son los tramos de un mismo circuito —a liquidar → para aprobar → favorables →
 * altas → deudores— y en la planilla son solapas de un mismo archivo: se pasa de una a otra sin
 * pensarlo. Obligar a volver al menú lateral entre tramo y tramo rompe esa costumbre.
 *
 * Se arma con el registro LISTADOS (definiciones.js), así que un listado nuevo aparece acá solo,
 * en el orden en que está declarado — que es el orden del circuito, no el alfabético.
 */
export default function AccesosListados({ actual }) {
    const navigate = useNavigate();

    const boton = (listado) => {
        const esActual = listado.clave === actual;
        return (
            <button
                key={listado.clave}
                type="button"
                onClick={() => !esActual && navigate(listado.ruta)}
                // aria-current además del color: quien navega con lector de pantalla también
                // tiene que saber en qué listado está parado.
                aria-current={esActual ? 'page' : undefined}
                title={listado.subtitulo}
                className="btn btn-sm d-flex align-items-center gap-2"
                style={{
                    borderRadius: 20,
                    padding: '0.35rem 0.9rem',
                    fontWeight: esActual ? 600 : 500,
                    cursor: esActual ? 'default' : 'pointer',
                    background: esActual ? '#1e40af' : '#fff',
                    color: esActual ? '#fff' : '#475569',
                    border: `1px solid ${esActual ? '#1e40af' : '#e2e8f0'}`,
                }}
            >
                <i className={listado.icono} />
                {listado.titulo}
            </button>
        );
    };

    // Los 5 tramos del ciclo primero; los listados auxiliares (Jauregui...) después de un separador.
    return (
        <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            {LISTADOS_CICLO.map(boton)}
            {LISTADOS_OTROS.length > 0 && (
                <span aria-hidden="true" style={{ width: 1, alignSelf: 'stretch', background: '#cbd5e1', margin: '0 0.25rem' }} />
            )}
            {LISTADOS_OTROS.map(boton)}
        </div>
    );
}
